import { render, staticRenderFns } from "./newArticleDetails.vue?vue&type=template&id=d07f7d62&scoped=true"
import script from "./newArticleDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./newArticleDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./newArticleDetails.vue?vue&type=style&index=0&id=d07f7d62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07f7d62",
  null
  
)

export default component.exports